import { actionGenerator } from '../../../../redux/actionGenerator';
import { ECompanyType } from '../../../../repositories/coworking/v1/apply-for-publication';

import { EPlacementApplicationFormFields } from '../enums';

import { onChangeInput } from './utils';
import { EValidateActionTypes } from './enums';

export const setPhoneFieldValueAction = onChangeInput(
  actionGenerator<EPlacementApplicationFormFields.Phone, string>(EPlacementApplicationFormFields.Phone),
);

export const setEmailFieldValueAction = onChangeInput(
  actionGenerator<EPlacementApplicationFormFields.Email, string>(EPlacementApplicationFormFields.Email),
);

export const setCompanyNameFieldValueAction = onChangeInput(
  actionGenerator<EPlacementApplicationFormFields.CompanyName, string>(EPlacementApplicationFormFields.CompanyName),
);

export const setCompanyTypeFieldValueAction = actionGenerator<
  EPlacementApplicationFormFields.CompanyType,
  ECompanyType
>(EPlacementApplicationFormFields.CompanyType);

export const validateAllAction = actionGenerator<EValidateActionTypes.ValidateAll>(EValidateActionTypes.ValidateAll);

export const validateByFieldAction = actionGenerator<
  EValidateActionTypes.ValidateByField,
  EPlacementApplicationFormFields
>(EValidateActionTypes.ValidateByField);
